{
	"backToStartPage": "Back to start page",
	"transactionDetailsTitle": "Transaction details",
	"btnVerifyTransactions": "Verify transactions",
	"kpi": {
		"date": "Date",
		"quantity": "Quantity",
		"carbonReductions": "Carbon reductions"
	},
	"verifyTransactionModal": {
		"title": "Verify transaction",
		"description": "Please enter the Record ID for this transaction. You can find the information on the declaration.",
		"recordIdLabel": "Record ID",
		"cancelTitle": "Cancel",
		"verifyTitle": "Verify",
		"errors": {
			"recordIdRequired": "Record ID is required",
			"recordIdInvalid": "Record ID must be 16 characters (letters or numbers), formatted like ABCD 1234 EFGH 5678",
			"verificationFailed": "The transaction could not be verified. Please check the Record ID"
		}
	},
	"errors": {
		"notFound": "Transaction not found"
	}
}
